const s = {
  'next': 'Далее',
  'prev': 'Назад',
  'select...': 'выбирать...',
  'brand': 'Бренд',
  'select a date': 'Выбрать дату',
  'select hour': 'Выбрать время',
  'day': 'дату',
  'time': 'Время',
  'location': 'Место',
  'your data': 'Ваши данные',
  'date and time': 'Дата и время',
  'num people': 'Кол-во участников',
  'err num people': 'Выберите количество людей',
  'workshop list': 'Список мастер-классов',
  'signup': 'Регистрация',

  'first name': 'Имя',
  'last name': 'Фамилия',
  'name': 'Ф.И.О.',
  'appointment day': 'Дата проведения',
  'email': 'Email',
  'phone': 'Телефон',
  'phone_scemi': 'Телефон',
  'phone_scemi_placeholder': '333 12345678',
  'prefix_scemi_placeholder': '+39',
  'whatsapp': 'WhatsApp',
  'appointment type': 'Тип записи',
  'preferred contact': 'Предпочитаемый способ связи',
  'preferred language': 'Предпочитаемый язык',
  'product category': 'Категория продукта',
  'notes': 'Примечания',
  'subscribe to newsletter': 'Iscriviti alla newsletter',
  'slot unavailable': 'Выбранное время больше недоступно',
  'choose another time slot': 'Scegli un altro orario',
  'confirm': 'Подтвердить',
  'sending': 'Идет отправка',
  'appointment confirmed': 'Благодарим за бронирование!<br>В ближайшее время Вы получите письмо-подтверждение по электронной почте.',

  'onsite': 'Офлайн',
  'online': 'Онлайн',

  'italian': 'Итальянский',
  'english': 'Английский',
  'french': 'Французский',
  'chinese': 'Китайский',
  'russian': 'Русский',
  'japanese': 'Японский',
  'korean': 'Корейский',

  'Abbigliamento Bambino': 'ДЕТСКАЯ ОДЕЖДА',
  'Abbigliamento Donna': 'ЖЕНСКАЯ ОДЕЖДА',
  'Abbigliamento Uomo': 'МУЖСКАЯ ОДЕЖДА',
  'Accessori': 'АКСЕССУАРЫ',
  'Arredamento': 'ПРЕДМЕТЫ ИНТЕРЬЕРА',
  'Borse': 'СУМКИ',
  'Calzature': 'ОБУВЬ',
  'Calzature Donna': 'ЖЕНСКАЯ ОБУВЬ',
  'Calzature Uomo': 'МУЖСКАЯ ОБУВЬ',
  'Fragranze': 'АРОМАТИЗАТОРЫ',
  'Gioielleria': 'УКРАШЕНИЯ',
  'Occhiali Da Sole': 'СОЛНЕЧНЫЕ ОЧКИ',
  'Orologi': 'ЧАСЫ',
  'Pelletteria': 'Leathergoods',
  'Pellicceria': 'Fur Goods',

  'fill all fields': 'поля, обязательные для заполнения',
}

export default s;